module.exports = __webpack_public_path__ + "plot-generator/static/media/logos_2p.8a3ab58b.png";